import ServicesLayout from '@/components/Pages/Services/ServicesLayout';
import Container from '@/components/common/Container';
import Heading from '@/components/common/Heading';
import PrivacyTerms from '@/components/PrivacyTerms/PrivacyTerms';
import Section from '@/components/common/Section';

import privacyTerms from '@/db/terms-conditions/terms-conditions.json';

const TermsCondition = () => {
  return (
    <Container>
      <Section>
        <Heading headingLevel="h1" className="mb-12">
          Terms Condition
        </Heading>
        <PrivacyTerms privacyTerms={privacyTerms} />
      </Section>
    </Container>
  );
};

TermsCondition.PageLayout = ServicesLayout;

export default TermsCondition;
